import React, { useState, useEffect, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import api from "../api";
import VehicleTable from "./VehicleTable";

const CarAvailabilityModal = ({ isOpen, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  const ownershipOptions = [
    { value: 1, label: "Aquila" },
    { value: 2, label: "Sixt" },
  ];

  const vehicleTypeOptions = [
    { value: 1, label: "Alta Gamma" },
    { value: 2, label: "Estándar" },
  ];

  useEffect(() => {
    async function fetchVehicles() {
      try {
        setLoading(true);
        const response = await api.vehicles.getMulti();

        const vehiclesWithLabels = response.map((vehicle) => ({
          ...vehicle,
          ownership:
            ownershipOptions.find((o) => o.value === vehicle.ownership)
              ?.label || "Desconocido",
          vehicleType:
            vehicleTypeOptions.find((v) => v.value === vehicle.vehicleType)
              ?.label || "Desconocido",
        }));

        setData(vehiclesWithLabels);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
      } finally {
        setLoading(false);
      }
    }
    if (isOpen) fetchVehicles();
  }, [isOpen]);

  const handleAvailabilityChange = (index, currentAvailability) => {
    const updatedData = [...data];
    updatedData[index].status = currentAvailability === 1 ? 0 : 1;
    setData(updatedData);
  };

  const handleSave = async () => {
    const payload = {
      vehicles: data.map((vehicle) => ({
        id: vehicle.id,
        is_available: vehicle.status === 1,
      })),
    };

    try {
      setIsSaving(true);
      const response = await api.vehicles.updateAvailability(payload);
      console.log("Disponibilidad actualizada:", response);
      onClose();
    } catch (error) {
      console.error("Error al actualizar la disponibilidad:", error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4"
              enterTo="opacity-100 translate-y-0"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-4"
            >
              <Dialog.Panel className="relative bg-white rounded-lg shadow-lg w-full max-w-4xl p-8 space-y-4">
                <Dialog.Title
                  as="h2"
                  className="poppins-medium text-lg font-bold text-[#1F384C] tracking-wider"
                >
                  Vehículos disponibles
                </Dialog.Title>
                <p className="poppins-regular text-xs text-[#8F99A6]">
                  Selecciona los vehículos disponibles
                </p>
                <VehicleTable
                  data={data}
                  loading={loading}
                  onChange={handleAvailabilityChange}
                />
                <div className="flex justify-end">
                  <button
                    onClick={handleSave}
                    className={`bg-[#BE202F] text-white text-xs py-4 px-4 rounded-2xl tracking-wider poppins-medium focus:outline-none ${
                      isSaving ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                    disabled={isSaving}
                  >
                    {isSaving ? "Guardando..." : "Guardar"}
                  </button>
                </div>
                <button
                  onClick={onClose}
                  className="absolute top-4 right-4 text-[#000000] hover:text-gray-600 focus:outline-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    className="w-8 h-8"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default CarAvailabilityModal;
